import axios from '../api/axios'

export default {
    getLst({params, callback}){ // 列表
        axios.post(`/v1/admin/posBrand/list`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    addPos({params, callback}){ // 新增
        axios.post(`/v1/admin/posBrand/add`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    updatePos({params, callback}){ // 更新pos品牌
        axios.put(`/v1/admin/posBrand/update`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    delPos({params, callback}){ // 删除
        axios.delete(`/v1/admin/posBrand/delete/${params}`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/pos.js